import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const messages = [
	"Aguarde um momento...",
	"Salvando o Chatbot...",
	"Estamos processando tudo...",
];

export default function FullScreenLoader() {
	const [messageIndex, setMessageIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
		}, 3000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div
			style={{
				position: "fixed",
				inset: 0,
				width: "100%",
				height: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				// scrim claro com leve blur em vez do preto 50% + caixa "muddy"
				background: "rgba(18, 18, 18, 0.38)",
				backdropFilter: "blur(3px)",
				WebkitBackdropFilter: "blur(3px)",
				zIndex: 1500,
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 16,
					background: "#ffffff",
					padding: "26px 34px",
					borderRadius: 14,
					boxShadow: "0 12px 40px rgba(18, 18, 18, 0.22)",
					fontFamily:
						'var(--rv-font-body, "Figtree", system-ui, -apple-system, sans-serif)',
				}}
			>
				<motion.span
					aria-hidden
					animate={{ rotate: 360 }}
					transition={{ repeat: Infinity, duration: 0.8, ease: "linear" }}
					style={{
						width: 34,
						height: 34,
						borderRadius: "50%",
						border: "3px solid rgba(18, 18, 18, 0.12)",
						borderTopColor: "var(--rv-orange, #FF7A00)",
						boxSizing: "border-box",
					}}
				/>
				<motion.span
					key={messageIndex}
					initial={{ opacity: 0, y: 8 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -8 }}
					transition={{ duration: 0.4 }}
					style={{
						color: "var(--rv-gray-600, #484747)",
						fontSize: 16,
						fontWeight: 500,
					}}
				>
					{messages[messageIndex]}
				</motion.span>
			</div>
		</div>
	);
}
